import React from 'react';
import {
  Box,
  Card,
  Flex,
  Icon,
  IconButton,
  Popover,
  PopoverContent,
  PopoverTrigger,
  Text,
} from 'pounceV2';
import { useTheme } from '@mui/material';

type EditMenuProps = {
  onEdit: React.MouseEventHandler<HTMLButtonElement>;
  onDelete?: React.MouseEventHandler<HTMLButtonElement>;
  useIcons?: boolean;
};
const EditMenuV3: React.FC<EditMenuProps> = ({ onEdit, onDelete, useIcons = false }) => {
  const {
    palette: { tokens, componentTokens },
  } = useTheme();
  return (
    <Popover>
      {({ close: closePopover }) => (
        <React.Fragment>
          <Box>
            <PopoverTrigger
              as={IconButton}
              icon="more"
              variant="ghost"
              size="medium"
              data-tid="renamable-tab-popover-trigger"
              aria-label="Tab Settings"
            />
          </Box>
          <PopoverContent alignment="bottom-left">
            <Card
              mt={0.5}
              as="ul"
              minWidth={100}
              shadow="dark300"
              sx={{
                backgroundColor:
                  componentTokens.selectMenuItems.color.item.background.containerBase,
              }}
            >
              <Box
                p={4}
                as="li"
                cursor="pointer"
                _hover={{ backgroundColor: tokens.background.neutral.mid[3] }}
                onClick={event => {
                  onEdit(event);
                  closePopover();
                }}
              >
                <Flex gap={2}>
                  {useIcons && <Icon type="pencil" size="medium" />}
                  <Text>Rename</Text>
                </Flex>
              </Box>
              {Boolean(onDelete) && (
                <Box
                  p={4}
                  as="li"
                  cursor="pointer"
                  _hover={{ backgroundColor: tokens.background.neutral.mid[3] }}
                  onClick={event => {
                    onDelete(event);
                    closePopover();
                  }}
                >
                  <Flex gap={2}>
                    {useIcons && <Icon type="trash" size="medium" />}
                    <Text>Delete</Text>
                  </Flex>
                </Box>
              )}
            </Card>
          </PopoverContent>
        </React.Fragment>
      )}
    </Popover>
  );
};

export default React.memo(EditMenuV3);
